import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const OpsMiscTools : React.FC = () => {
    return (
        <Grid container direction='column'>
            <Grid item>
                <Typography variant='h2'>Other tools</Typography>
            </Grid>
        </Grid>
    )
}

export default OpsMiscTools;